export function reportTaskId(params: URLSearchParams): number | undefined {
  const raw = params.get("task_id");
  if (!raw || !/^\d+$/.test(raw)) return undefined;
  const id = Number(raw);
  return Number.isSafeInteger(id) && id > 0 ? id : undefined;
}

export function updateReportSearch(params: URLSearchParams, key: "task_id" | "tab", value?: string | number) {
  const next = new URLSearchParams(params);
  if (value === undefined || value === "") next.delete(key);
  else next.set(key, String(value));
  return next;
}

export function reportTaskOptions(items: { id: number; payload: { title: string } }[] | undefined, selectedId?: number) {
  const options = (items || []).map((task) => ({ value: task.id, label: task.payload.title }));
  // A bookmarked task remains selectable even when it is outside the latest 100 tasks.
  if (selectedId !== undefined && !options.some((option) => option.value === selectedId)) {
    options.unshift({ value: selectedId, label: "所选任务（名称加载中）" });
  }
  return options;
}
